import { SwiperSlide } from "swiper/react";
import Swiper from "./Swiper";
import styled from "styled-components";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { PuffLoader } from "react-spinners";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ReactGA from "react-ga4";
import { EssentialsDataContext } from "../../Contexts/EssentialsDataContext";
import { AnswersContext } from "../../Contexts/AnswerContext";
// import { ADVISER_IDENTIFIER, ANSWERS_API_URL, EMAIL_TO, PREDICT_API_URL, PRETICTION_API_URL, SERVICES_API_URL } from "../../env";
import { ADVISER_IDENTIFIER, ANSWERS_API_URL, EMAIL_TO, PRETICTION_API_URL } from "../../env";
import { CarouselStyled, LoaderContainer } from "../../styles/Screens/Recommendations";
import { Title, Text } from "../../styles/Texts";
import { CardSlider } from "./CardSlider";
import RatingStars from "../../components/RatingStars";
import { GenericButton } from "../../components/UI-KIT/GenereicButton";
import { T } from "../../styles/Theme";
import { sendNotificationEmail } from "../../utils/requests";
import { parseRecommentaions } from "../../utils/common";

export const Recomendations = () => {
  const [
    ,
    setFinalForm,
    ,
    setScreenNumber,
    ,
    ,
    ,
    ,
    ,
    setQuestionId,
    ,
    setCurrentPage,
  ] = useContext(EssentialsDataContext);
  const [answers, setAnswers] = useContext(AnswersContext);

  const [data, setData] = useState<any[] | null>(null);
  const [length, setLength] = useState(1);

  const [finalForm] = useContext(EssentialsDataContext);

  const copyFinalForm: any[] = [];

  finalForm.forEach((el: any) => {
    const { id_question, answer } = el;
    copyFinalForm.push({ id_question, answer });
  });

  const post = {
    data: copyFinalForm,
  };

  const config = {
    headers: {"Content-Type": "application/json",}
    };

  // useEffect(() => {
  //   const url = `${SERVICES_API_URL}/${ADVISER_IDENTIFIER}/services/recommended/`;

  //   axios.post(`${PREDICT_API_URL}/api/v1/predict/`, post, config)
  //     .then((res) => {
  //       return res.data.result;
  //     })
  //     .then(async (result) => {
  //       const arrItems: Array<any> = result;
  //       const body = JSON.stringify({services_ids: arrItems });

  //       await axios.post(url, body, config)
  //         .then(res => {
  //           setData(res.data);
  //           if (res.data && res.data.length > 0) {
  //             setLength(res.data.length);
  //           }
  //         })

  //       // for (const el of result) {
  //       //   const res = await axios.get(`${url}1/`);
  //       //   await arrItems.push(res.data);
  //       //   setData([...arrItems]);
  //       // }
  //     })
  //     .then(() => {
  //       if (!window.sessionStorage.getItem("tryadviser-adviseGenerated")) {
  //         // ReactGA.event({
  //         //   category: "Recomendador",
  //         //   action: "Recomendación Generada",
  //         //   label: "recomendacion_generada",
  //         // });
  //         window.sessionStorage.setItem("tryadviser-adviseGenerated", "true");
  //       }
  //       submitAnswers();
  //     });
  // }, []);

  // useEffect(() => {
  //   const url = `${SERVICES_API_URL}/${ADVISER_IDENTIFIER}/services/recommended/`;

  //   axios.post(`${PREDICT_API_URL}/api/v1/predict/`, post, config)
  //     .then((res) => {
  //       return res.data.result;
  //     })
  //     .then(async (result) => {
  //       const arrItems: Array<any> = result;
  //       const body = JSON.stringify({services_ids: arrItems });

  //       await axios.post(url, body, config)
  //         .then(async responseServices => {
  //           setData(responseServices.data);
  //           setLength(responseServices.data?.length);
  //           const results = responseServices.data;
  //           return results;
  //         })
  //         .then(async (results: any) => {
  //           submitAnswers(results);
  //         });
  //     })
  // }, []);

  useEffect(() => {

    const question_answers = finalForm
    // console.log("finalForm", finalForm)
    // console.log("question_answers", question_answers)
    const prediction_data = {
      data: question_answers
    }
    // console.log("prediction_data", prediction_data)
    axios.post(`${PRETICTION_API_URL}/api/v1/predict/`, prediction_data, config)
      .then((responseServices) => {
        const results = responseServices.data?.data || [];
        setData(results);
        setLength(results.length);
        // console.log("responseServices", results);
        return results;
      })
      .then((results: any[]) => {
        submitAnswers(results);
      })
      .catch((err) => {
        console.log("err predict", err);
      });
      
  }, []);


  const submitAnswers = async (recommendationsArray: any) => {
    const dataPost = {
      answers: {
        data: finalForm,
      },
      results: null,
    };

    await axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/`, dataPost, config)
      .then(response => {
        if (response.status === 201) {
          setAnswers({...answers, idAnswer: response.data.id});
          const answerId = response.data.id;
          return answerId
        }
      })
      .then((answerId: any) => {
        if (recommendationsArray) {
          const bodyRecommendations = {
            answer_id: answerId,
            recommendations: parseRecommentaions(recommendationsArray)
          }
          axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/recommendations/`, bodyRecommendations).then()
        }
          if (answers.email) {
            const emailData = {
              answer_id: answerId,
              email: answers.email,
            }
            axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/emails/`, emailData).then()
          }
      })
  }

  const submitSelectedService = async (item: any) => {
    const dataPost = {
      results: {
        data: [item],
      }
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };
    // console.log(typeof answers.idAnswer)
    await axios.put(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/${answers.idAnswer}/`, dataPost, config)
      .then(response => {
        if (response.status === 200) {
          console.log("updated!");
        }
      }).then(() => {
        const body = {
          email_to: EMAIL_TO,
          link: (item.links.length > 0) ? item.links[0].link : "",
          image: (item.images.length > 0) ? item.images[0].image_url : "",
          product_name: item.name,
          product_description: "",
          email: (answers.email) ? answers.email : "",
          data: finalForm
        }
        sendNotificationEmail(body).then((res) => {console.log("EMAIL HAS BEEN SENT", res.status)})
      })
      .catch(error => {
        console.log(error);
      });
  }

  return (
    <CarouselStyled>
      {data ? (
        <div className="header">
          <TitleStyled>
            Te recomendamos {length} {length === 1 ? "producto" : "productos"}
          </TitleStyled>
          <TextStyled>Desliza para comparar las opciones</TextStyled>
        </div>
      ) : (
        <div className="headerSkeleton">
          <Title>
            <Skeleton />
          </Title>
          <TextStyled>
            <Skeleton />
          </TextStyled>
        </div>
      )}

      {data ? (
        <Swiper>
          {data.map((item, i) => {
            return (
              <SwiperSlide key={i}>
                <CardSlider
                  data={item}
                  onSelectService={() => submitSelectedService(item)}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <>
          <LoaderContainer>
            <PuffLoader color={T.primary} size={130} />
          </LoaderContainer>
        </>
      )}

      {data && (
        <>
          <RatingStars />
          <div className="buttonContainer">
            <GenericButton
              bg={T.primary}
              c="white"
              onClick={() => {
                setScreenNumber(0);
                setCurrentPage(0);
                setQuestionId(1);
                setFinalForm([]);
              }}
            >
              Volver a empezar
            </GenericButton>
          </div>
        </>
      )}
    </CarouselStyled>
  );
};

const TitleStyled = styled(Title)`
  margin: 30px 0 10px 0;
  font-weight: ${T.fontWeights.bold};
`;

const TextStyled = styled(Text)`
  padding: 0 20px 0px 20px;

  @media(max-width: 480px) {
    font-size: ${T.fontSizes.medium};
  }
`;
